"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EnterAmount = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable no-restricted-globals */
/* eslint-disable no-useless-escape */
/* eslint-disable consistent-return */
/* eslint-disable @typescript-eslint/no-shadow */
/* eslint-disable radix */
/* eslint-disable max-len */
const react_1 = require("react");
const sdk_1 = __importDefault(require("@twa-dev/sdk"));
const de_ui_1 = require("@delab-team/de-ui");
const react_i18next_1 = require("react-i18next");
const tonapi_1 = require("../../../../logic/tonapi");
const use_media_query_1 = require("../../../../utils/use-media-query");
const formatNumber_1 = require("../../../../utils/formatNumber");
const enter_amount_module_css_1 = __importDefault(require("./enter-amount.module.css"));
const titleTgStyles = { color: 'var(--tg-theme-text-color)' };
const EnterAmount = (props) => {
    const { t } = (0, react_i18next_1.useTranslation)();
    const inputRef = (0, react_1.useRef)(null);
    const focusInput = () => {
        if (inputRef.current) {
            inputRef.current.focus();
        }
    };
    (0, react_1.useEffect)(() => {
        focusInput();
    });
    const [amount, setAmount] = (0, react_1.useState)('0');
    const isMobile = (0, use_media_query_1.useMediaQuery)(340);
    const [amountUsd, setAmountUsd] = (0, react_1.useState)(undefined);
    const dynamicMaxWidth = `${Math.max((amount.length * 18), 21)}px`;
    const TgObj = sdk_1.default;
    const tonapi = new tonapi_1.TonApi();
    const validateButton = (amount) => {
        const amountValue = parseFloat(amount.replace(',', '.'));
        return (/^\d+(\.\d+)?$/.test(String(amountValue))
            && amountValue >= 0.00001
            && amountValue <= 1500000);
    };
    const sanitizedAmount = amount.replace(',', '.');
    const amountValue = parseFloat(sanitizedAmount);
    // const availableBalanceValue = ((parseFloat(props.sendData.availableBalance.replace(',', '.')) - 0.03) > 0) ? parseFloat(props.sendData.availableBalance.replace(',', '.')) - 0.03 : 0
    const availableBalanceValue = (0, react_1.useMemo)(() => {
        if ((parseFloat(props.sendData.availableBalance.replace(',', '.')) - 0.03) < 0) {
            return 0;
        }
        return (parseFloat(props.sendData.availableBalance.replace(',', '.')) - 0.03);
    }, [props.sendData.token, props]);
    (0, react_1.useEffect)(() => {
        if (props.position !== 2 || !props.sendData.availableBalance)
            return;
        TgObj.MainButton.show();
        if (amountValue > availableBalanceValue || !validateButton(sanitizedAmount) || !/^\d+(\.\d+)?$/.test(sanitizedAmount)) {
            TgObj.MainButton.disable();
            TgObj.MainButton.text = Number(amountValue) === 0 ? t('send.enter-amount-position.enter-amount') : t('send.enter-amount-position.insufficient-balance');
            TgObj.MainButton.color = '#424B56';
        }
        else {
            TgObj.MainButton.enable();
            TgObj.MainButton.color = '#007AFF';
            TgObj.MainButton.text = t('send.enter-amount-position.proceed');
        }
        const handleBtnClick = () => {
            console.log('handleBtnClick ENTER AMOUNT');
            props.setSendData({ ...props.sendData, amount: sanitizedAmount });
            props.setPosition(3);
            TgObj.MainButton.offClick(handleBtnClick);
        };
        TgObj.MainButton.onClick(handleBtnClick);
        return () => {
            TgObj.MainButton.offClick(handleBtnClick);
        };
    }, [sanitizedAmount, props.position === 2, props.sendData.availableBalance, props.sendData]);
    (0, react_1.useEffect)(() => {
        const getAmountUSD = async () => {
            try {
                const res = await tonapi.getTokenPrice(props.sendData.tokenAddress, 'usd');
                if (res) {
                    const firstRateKey = Object.keys(res.rates)[0];
                    const firstRate = res.rates[firstRateKey];
                    setAmountUsd(firstRate.prices.USD);
                }
            }
            catch (error) {
                console.error(error);
            }
        };
        getAmountUSD();
    }, [props.position === 2]);
    return ((0, jsx_runtime_1.jsxs)("div", { className: enter_amount_module_css_1.default.container, children: [(0, jsx_runtime_1.jsx)(de_ui_1.Text, { className: enter_amount_module_css_1.default.modalTitle, children: t('send.enter-amount') }), (0, jsx_runtime_1.jsxs)("div", { className: enter_amount_module_css_1.default.amountContainer, children: [(0, jsx_runtime_1.jsxs)("div", { className: enter_amount_module_css_1.default.usdContainer, children: [(0, jsx_runtime_1.jsx)(de_ui_1.Text, { className: enter_amount_module_css_1.default.youPay, children: t('trans-detail.you-send2') }), amountUsd && amountUsd.length !== 0 && amount.length !== 0 && !isNaN(parseFloat(amount))
                                && (0, jsx_runtime_1.jsxs)(de_ui_1.Text, { className: enter_amount_module_css_1.default.usdAmount, children: ["~ ", (parseFloat(amount) * parseFloat(amountUsd)).toLocaleString('en-US', { style: 'currency', currency: 'USD' })] })] }), (0, jsx_runtime_1.jsxs)("div", { className: enter_amount_module_css_1.default.amountInner, onClick: focusInput, children: [(0, jsx_runtime_1.jsx)("input", { ref: inputRef, type: 'text', style: { maxWidth: dynamicMaxWidth }, className: `${enter_amount_module_css_1.default.amountInput} ${amountValue > availableBalanceValue ? enter_amount_module_css_1.default.amountInputError : ''}`, value: amount, inputMode: "decimal", pattern: "[0-9]*[.,]?[0-9]*", onChange: (e) => {
                                    let inputValue = e.target.value.replace(/,/g, '.');
                                    inputValue = inputValue.replace(/^0+(?!$|\.)/, '');
                                    inputValue = inputValue.replace(/[^0-9.]+/, '');
                                    inputValue = inputValue.length === 0 ? '0' : inputValue;
                                    // const isValidInput = /^\d*\.?\d*$/.test(inputValue)
                                    const isValidInput = /^-?\d*\.?\d*$/.test(inputValue);
                                    if (isValidInput) {
                                        setAmount(inputValue);
                                    }
                                } }), (0, jsx_runtime_1.jsx)(de_ui_1.Div, { className: `${enter_amount_module_css_1.default.token} ${amountValue > availableBalanceValue ? enter_amount_module_css_1.default.amountInputError : ''}`, children: props.sendData.token })] }), (0, jsx_runtime_1.jsx)("div", { className: enter_amount_module_css_1.default.line }), (0, jsx_runtime_1.jsx)("div", { className: enter_amount_module_css_1.default.options, children: (0, jsx_runtime_1.jsx)("div", { className: enter_amount_module_css_1.default.option, children: (0, jsx_runtime_1.jsxs)(de_ui_1.Text, { className: enter_amount_module_css_1.default.optionText, children: [t('send.enter-amount-position.available'), " ", (0, formatNumber_1.formatNumber)(String(availableBalanceValue)), " ", props.sendData.token] }) }) })] })] }));
};
exports.EnterAmount = EnterAmount;
